module.exports = __webpack_public_path__ + "static/media/dog.e463e47a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/dog.svg
// module id = 477
// module chunks = 0